import React, { useState } from 'react';
import { Navigate } from 'react-router-dom';
import { compileWithArgs } from 'src/js/helper/path-to-regexp-helper';
import { useStores } from 'src/js/hook/use-stores';
import { MakitoPaths } from 'src/js/route';
import { constant } from 'src/js/constant';
import { useReadLocalStorage } from 'usehooks-ts';

import { LogosPage } from './logos/logos';
import { RecordingsPage } from './recordings/recordings';
import { AssetSingle } from './recordings/asset-single';
import systemInfo from 'src/js/data/systemInfo';
import locationStore from 'src/js/store/location-store';

export type MediaPageParameters = {
  page?: MediaKey;
};

export enum MediaKey {
  RECORDINGS = 'recordings',
  // ASSET_SINGLE = 'recordings/:id',
  LOGOS = 'logos',
}

export const DefaultMediaRoute: React.FunctionComponent = () => {
  const { sessionStore } = useStores();
  const selectedTab =
    useReadLocalStorage(`${constant.lStorage.mediaTab}:${sessionStore.username}`) ??
    (systemInfo.storage ? MediaKey.RECORDINGS : MediaKey.LOGOS);
  // console.log('DefaultMediaRoute selectedTab', selectedTab);

  const [selectedFolder] = useState<string | null>(locationStore.recordings);

  // Handle segmented navigation for recordings with selected folder
  let navigationPath;
  if (selectedTab === MediaKey.RECORDINGS && selectedFolder != null) {
    navigationPath = compileWithArgs(MakitoPaths.media + '/recordings/:id')({
      id: selectedFolder,
    });
  } else {
    navigationPath = compileWithArgs<MediaPageParameters>(MakitoPaths.media)({
      page: selectedTab as MediaKey, // show page in localstorage if a direct section access without any specific page
    });
  }

  return (
    <Navigate
      to={navigationPath}
      replace={
        true
      } /* replace current entry in history stack instead of adding new one, thus allowing to use back button a single time to go back (as expected) instead of two */
    />
  );
};

export const MediaRoutes = [
  {
    path: '',
    element: <DefaultMediaRoute />,
  },
  {
    path: 'recordings/:id/view',
    element: <AssetSingle />,
  },
  {
    path: 'recordings/:id',
    element: <RecordingsPage />,
  },
  {
    path: MediaKey.RECORDINGS,
    element: <RecordingsPage />,
  },
  {
    path: MediaKey.LOGOS,
    element: <LogosPage />,
  },
];
